import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";
import { ExternalIcon } from "./ExternalIcon";

const CalendarIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <ExternalIcon size={size} color={color} testID={testID} svgName="calendar" />
);

export { CalendarIcon };
